import { pxToRem } from '@geneo2-web/shared-ui';
import { Box, Typography } from '@mui/material';

type SessionStatType =
  | 'correct'
  | 'incorrect'
  | 'skipped'
  | 'timedOut'
  | 'time'
  | 'accuracy'
  | 'avg';

interface ISessionStatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  type: SessionStatType;
  subtitle?: string;
}

export const SessionStatCard = ({
  icon,
  label,
  value,
  type,
  subtitle,
}: ISessionStatCardProps) => {
  const stylesByType = {
    correct: {
      border: '#bbf7d0',
      bg: '#f0fdf4',
      iconBg: '#dcfce7',
      iconColor: '#16a34a',
    },
    incorrect: {
      border: '#fecaca',
      bg: '#fef2f2',
      iconBg: '#fee2e2',
      iconColor: '#dc2626',
    },
    skipped: {
      border: '#fde68a',
      bg: '#fffbeb',
      iconBg: '#fef3c7',
      iconColor: '#d97706',
    },
    timedOut: {
      border: '#fde68a',
      bg: '#fffbeb',
      iconBg: '#fef3c7',
      iconColor: '#d97706',
    },
    time: {
      border: '#bfdbfe',
      bg: '#eff6ff',
      iconBg: '#dbeafe',
      iconColor: '#2563eb',
    },
    accuracy: {
      border: '#a5f3fc',
      bg: '#ecfeff',
      iconBg: '#cffafe',
      iconColor: '#0891b2',
    },
    avg: {
      border: '#f5d0fe',
      bg: '#fdf4ff',
      iconBg: '#fae8ff',
      iconColor: '#e11d48',
    },
  };

  const style = stylesByType[type];

  return (
    <Box
      sx={{
        borderRadius: pxToRem(12),
        padding: `${pxToRem(16)} ${pxToRem(12)}`,
        textAlign: 'center',
        border: `1px solid ${style.border}`,
        background: style.bg,
        boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          width: pxToRem(36),
          height: pxToRem(36),
          borderRadius: pxToRem(10),
          background: style.iconBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: pxToRem(10),
          color: style.iconColor,
          fontSize: pxToRem(16),
          lineHeight: 1,
        }}
      >
        {icon}
      </Box>

      <Box display="flex" flexDirection="column" gap={0.5} alignItems="center">
        <Typography
          sx={{
            fontSize: pxToRem(22),
            fontWeight: 800,
            color: '#1e293b',
            lineHeight: 1.1,
          }}
        >
          {value}
        </Typography>

        <Typography
          sx={{
            fontSize: pxToRem(11),
            fontWeight: 500,
            color: '#64748b',
            textTransform: 'uppercase',
            letterSpacing: 0.5,
          }}
        >
          {label}
        </Typography>

        {subtitle ? (
          <Typography
            sx={{
              fontSize: pxToRem(10),
              fontWeight: 500,
              color: '#94a3b8',
              lineHeight: 1.2,
              mt: 0.25,
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};
